import { giphyLightGrey } from '@giphy/js-brand'
import { Button as BrandButton } from '@giphy/react-giphy-brand'
import React, { useContext } from 'react'
import ModalContext from 'shared/components/context/modal'
import UserContext from 'shared/components/context/user'
import { IChannel } from 'shared/types/channel'
import styled from 'styled-components'

const Button = styled(BrandButton)`
    position: relative;
    margin-bottom: 10px;
`

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex: 1;
    flex-direction: column;
`
const Copy = styled.div`
    padding: 20px;
    color: ${giphyLightGrey};
`
const EmptyCollection = ({ channel }: { channel: IChannel }) => {
    const { openNewCollectionPanel } = useContext(ModalContext)
    const { user } = useContext(UserContext)
    return (
        <Container>
            <Copy>
                You don&apos;t have any collections yet! <br />
                Make your first by clicking the button below.{' '}
            </Copy>
            <Button
                onClick={() => {
                    openNewCollectionPanel({ parentChannel: channel, userId: user.id, redirectOnCreate: true })
                }}
            >
                Create New Collection
            </Button>
        </Container>
    )
}

export default EmptyCollection
